// scripts/modelist/references.mjs
// What one message to the Modelist carries, counted the same by the composer, the app's server and the runner. Under
// scripts/modelist/ because the runner's image holds nothing else of the repository (scripts/modelist/Dockerfile).
/** The files one message attaches (owner, 2026-10-10). Their bytes are bounded apart (lib/modelist/references.ts). */
export const MODELIST_REFERENCES_PER_MESSAGE = 10;
/** The pictures one step keeps in the conversation: what the runner sends of a message and what the app stores of any step. */
export const MODELIST_STEP_PICTURES = 6;
